import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MatDividerModule } from '@angular/material/divider'

import { CompanyFacade, RouterFacade, UiFacade } from '~/core/features'
import { EGuardSection } from '~/core/models'
import { LoadingComponent } from '~/ui/loading'

import { EpsPdfChartContainerComponent } from './lazy-components/eps-pdf-chart-container/eps-pdf-chart-container.component'
import { EpsRevChartContainerComponent } from './lazy-components/eps-rev-chart-container/eps-rev-chart-container.component'
import { ForecastEarnInfoComponent } from './components'

@Component({
  selector: 'app-earn',
  templateUrl: './earn.component.html',
  styleUrl: './earn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    MatDividerModule,
    LoadingComponent,
    ForecastEarnInfoComponent,
    EpsPdfChartContainerComponent,
    EpsRevChartContainerComponent,
    // ForecastHistoricalChartComponent,
  ],
})
export class EarnComponent {
  private readonly routerFacade = inject(RouterFacade)
  private readonly isCompanyPage = toSignal(this.routerFacade.isCompanyPage$)

  uiFacade = inject(UiFacade)

  readonly companyFacade = inject(CompanyFacade)

  readonly forecast = toSignal(this.companyFacade.forecast$)

  readonly guardSectionName$ = this.routerFacade.guardSectionName$

  readonly guardSection = computed(() =>
    this.isCompanyPage() ? EGuardSection.COMPANY_INFO_MAIN : EGuardSection.FORECAST_INFO_MAIN
  )

  readonly guardEpsPdfChart = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_CHART_EPS_PDF
      : EGuardSection.FORECAST_INFO_CHART_EPS_PDF
  )

  readonly guardEpsRevChart = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_CHART_REV_PDF
      : EGuardSection.FORECAST_INFO_CHART_REV_PDF
  )

  constructor() {}
}
